import React from "react";
import { Outlet } from "react-router-dom";

const FileManager = () => {
  return <Outlet />;
};

export default FileManager;
